module.exports = __webpack_public_path__ + "static/media/gryphon-house-storefront.1c3fe827.jpg";